import React from "react";
import { store } from '../../redux/store';
import { showBiometricSection } from '../../redux/div-show-and-hide/div-show-and-hide.action';
import GenerateRequestId from '../../common-function/GenerateRequestId';
import apiCallService from '../../service/api-call-service';
import { connect } from 'react-redux';
import { setUniqueRefNo } from '../../redux/on-boarding/on-boarding.action';
import { Snackbar } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';

class RblKyc extends React.Component{
    constructor(props){
        super(props);
        this.state={
            verifyUrl: '',
			curTime: new Date().toLocaleString(),
            messagePopUpHidden: false,
            message: '',
            severity: ''
        }
    }

    componentDidMount = async () => {

		const uniqueId = GenerateRequestId.geneRateRequestId();
		const requestToSend = {
            "request": {
                "userid": process.env.REACT_APP_On_Boarding_Rbl_Ott_User_Id,
                "password": process.env.REACT_APP_On_Boarding_Rbl_Ott_Pwd,
                "bcagentid": process.env.REACT_APP_On_Boarding_Rbl_Ott_Bcagent_Id,
                "cpuniquerefno": uniqueId,
                "datetime": this.state.curTime,
                "name": this.props.firstName+" "+this.props.lastName,
                "dob": this.props.dob,
                "address": "",
                "state": "",
                "city": "",
                "pincode": "",
                "mobile": this.props.mobile,
                "email": this.props.email,
                "pan": "",
                "req": "1",
                "bseg": "BAAS",
                "type": "A",
                "field13": "0032",
                "field14": "",
                "field15": "",
                "field16":""
            }
        }

        console.log('Rbl Ott Request ',requestToSend);

        const rblOttUrl = process.env.REACT_APP_On_Boarding_Rbl_Ott_Url;

        console.log('Rbl Ott Url ',rblOttUrl);

        const response = await apiCallService.postMethodCall(rblOttUrl, requestToSend);

        console.log('Rbl Ott Response ',response)

        if (!(response === undefined) && (response.response_code == 0)) {
			this.setState({ verifyUrl:response.response.url });
           
            this.setState({ messagePopUpHidden: true });
			this.setState({ severity: "success" });
            this.setState({message:response.response.statusMessage});          
		}
		else if (!(response === undefined) && !(response.response_description === undefined)) {
			this.setState({ messagePopUpHidden: true });
			this.setState({ severity: "error" });
			this.setState({ message: response.response_description });		
		} else {
			this.setState({ messagePopUpHidden: true })
			this.setState({message:response});
			this.setState({ severity: "error" });
		}

        store.dispatch(setUniqueRefNo({uniqueRefNo:uniqueId}));
	}

    submitFormData = async (event) => {

        event.preventDefault();

        store.dispatch(showBiometricSection());
    }
    
      render(){
          return(
            <div className="mid-contant">
            <div className="container">
                <form onSubmit={ this.submitFormData} autocomplete="off">
                <div className="row">
                    <div className="col-12">
                        <div className="head">					
                            <div className="step">
                                <ul>
                                    <li className="basic">										
                                        <i className="dot"></i>
                                        <i className="line"></i>
                                        <span className="litxt">Basic</span>
                                    </li>
                                    <li className="bioscan">										
                                        <i className="dot"></i>
                                        <i className="line"></i>
                                        <span className="litxt">Biomatric</span>
                                    </li>
                                    <li className="otp">							
                                        <i className="dot"></i>
                                        <i className="line"></i>
                                        <span className="litxt">OTP</span>
                                    </li>						
                                </ul>					
                            </div>					
                            <h2>RBL KYC Process</h2>
                        </div>
                    </div>
                    
                    <Snackbar
                       anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
					   open={this.state.messagePopUpHidden}
					   autoHideDuration={3000}
					   onClose={e => this.setState({ messagePopUpHidden: false })}
				    >
					   <Alert onClose={e => this.setState({ messagePopUpHidden: false })} severity={this.state.severity}>
						  {this.state.message}
					    </Alert>
				    </Snackbar>
                    
                    <div className="col-12">
                        <div className="kycboxiframe">					
                            <iframe src={this.state.verifyUrl}> </iframe>	
                            <button type="submit" className="btn btn-primary" id="">Submit</button>
                        </div>
                    </div>
                </div>
                </form>
            </div>
        </div>
            
        );
      } 
}

const mapStateToProps = ({ onBoarding: {firstName,lastName,mobile,email,dob} }) => ({
    firstName, lastName, mobile, email, dob
});

export default connect(mapStateToProps, null)(RblKyc);